import React from 'react';

import classNames from 'classnames';

import { Site } from '../../../modules/sites/Site';
import LazyImage from '../LazyLoad/LazyImage';
import SiteLogo from '../SiteLogo/SiteLogo';

import styles from './styles/spinner.css';

interface SpinnerProps {
  site: Site;
  LazyImage: typeof LazyImage;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ className, site, LazyImage }) => {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.overlay} />
      <div className={styles.main}>
        <SiteLogo site={site} LazyImage={LazyImage} className="spinner" />
      </div>
    </div>
  );
};

export default Spinner;
